export class SearchDataMissingError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "SearchDataMissingError";
  }
}
